module.exports = __webpack_public_path__ + "static/media/metafest-grid.68d70835.gif";